import PropTypes from 'prop-types';
import React from 'react';
import {repairTv} from 'src/shared/pagePaths';
import {button} from 'src/styles/modules/button.module.scss';
import DeflectionCall from 'src/svgs/scheduleCallback/DeflectionCall.svg';
import {DeflectionTV} from 'src/svgs/scheduleCallback/DeflectionTV';
import {header} from '../header.module.scss';
import {
  icons,
  interstitialButton,
  interstitialCard,
  interstitialHeader,
  recommended,
  suggestionText,
} from '../interstitial.module.scss';

export const TvInterstitial = ({
  onGetCall,
  onTvRepair,
}) => (
  <>
    <header className={header}>
      <h1>We can help with that</h1>
      <p>We found some common solutions to try first, or you can schedule a call below.</p>
    </header>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionTV className={icons} />
        <p>TV Troubleshooting<br /><span className={recommended}>Recommended</span></p>
        <a className={`${button} ${interstitialButton}`} href={repairTv()} onClick={onTvRepair}>Troubleshoot</a>
      </div>
      <hr />
      <div className={suggestionText}>
        <p>Troubleshooting solves most service issues and will help diagnose the problem if you need more help.</p>
        <p> You&apos;ll use the same tools our agents use to troubleshoot on the phone.</p>
      </div>
    </div>

    <div className={interstitialCard}>
      <div className={interstitialHeader}>
        <DeflectionCall className={icons} />
        <p>I&apos;d like to speak with an agent</p>
        <button className={`${button} ${interstitialButton}`} onClick={onGetCall}>Get a Call</button>
      </div>
    </div>
  </>
);

TvInterstitial.propTypes = {
  onGetCall: PropTypes.func.isRequired,
  onTvRepair: PropTypes.func.isRequired,
};
